import React from 'react'
import Form from "../form/Form"

const FormView = () => {
  return (
    <>
        <Form />
    </>
  )
}

export default FormView